import React from "react";
import styled from "styled-components";
import Label from "Shared/Form/Label";
import Input from "Shared/Form/Input";
import FieldError from "Shared/Form/FieldError";

interface Field {
    component?: any;
    name: string;
    id: string | number;
    label?: string;
    inputProps?: any;
    wrapper?: any;
    inputComponent?: any;
}

interface FieldProps {
    field: Field;
    onChange: (e: { target: { value: string; name?: string } }) => void;
    onBlur: (e: { target: { value: string; name?: string } }) => void;
    value: string | null;
    children?: React.ReactNode;
    error?: any;
}

export const Field = ({ field, value, children, onChange, error, onBlur }: FieldProps) => {
    const InputField = field.component || Input;
    const FieldWrapper = field.wrapper || FormGroup;

    return (
        <FieldWrapper className="EmploymentInfo__field" key={field.id}>
            <Label htmlFor={field.name}>{field.label}</Label>
            <InputField
                id={field.id}
                name={field.name}
                value={value}
                onChange={onChange}
                hasLabel={true}
                hasError={!!error}
                error={!!error}
                onBlur={onBlur}
                {...field.inputProps}
            />
            <FieldError>{error}</FieldError>
            {children && children}
        </FieldWrapper>
    );
};

Field.displayName = "EmploymentInfoField";

const FormGroup = styled("div")`
    margin-bottom: 20px;

    input,
    label {
        display: block;
    }
`;
